var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11104_7729",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11104_7729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37499 16.3077V10.359L4.16666 7.34294V13.1475C4.16666 13.1902 4.17735 13.2302 4.19874 13.2677C4.22013 13.3051 4.25214 13.3371 4.29478 13.3638L9.37499 16.3077ZM10.625 16.3077L15.7052 13.3638C15.7478 13.3371 15.7799 13.3051 15.8012 13.2677C15.8226 13.2302 15.8333 13.1902 15.8333 13.1475V7.34294L10.625 10.359V16.3077ZM9.24687 17.6715L3.66999 14.4615C3.43277 14.3248 3.24791 14.1422 3.11541 13.9136C2.98291 13.6848 2.91666 13.4337 2.91666 13.1602V6.83981C2.91666 6.56634 2.98291 6.31523 3.11541 6.08648C3.24791 5.85787 3.43277 5.67523 3.66999 5.53856L9.24687 2.32856C9.48395 2.19176 9.73499 2.12335 9.99999 2.12335C10.265 2.12335 10.516 2.19176 10.7531 2.32856L16.33 5.53856C16.5672 5.67523 16.7521 5.85787 16.8846 6.08648C17.0171 6.31523 17.0833 6.56634 17.0833 6.83981V13.1602C17.0833 13.4337 17.0171 13.6848 16.8846 13.9136C16.7521 14.1422 16.5672 14.3248 16.33 14.4615L10.7531 17.6715C10.516 17.8083 10.265 17.8767 9.99999 17.8767C9.73499 17.8767 9.48395 17.8083 9.24687 17.6715ZM13.2131 7.41669L15.1458 6.30773L10.1281 3.40544C10.0855 3.37877 10.0428 3.36544 9.99999 3.36544C9.95721 3.36544 9.9145 3.37877 9.87187 3.40544L8.06249 4.4471L13.2131 7.41669ZM9.99999 9.2821L11.9375 8.16023L6.79166 5.18585L4.85416 6.30773L9.99999 9.2821Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage2);
export default __webpack_public_path__ + "static/media/package_2.f5dd60fc5a5109ff39bb144d9f548331.svg";
export { ForwardRef as ReactComponent };